import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../';

interface ChatbotState {
  isLoading: boolean,
  email: string,
  farmChatResults: any,
  dataChatResults: any,
  questions: any
}

const initialState = {
  isLoading: false,
  email: "HEATHADKISSON@GMAIL.COM",
  farmChatResults: [],
  dataChatResults: [],
  questions: []
} as ChatbotState

const chatbotSlice = createSlice({
  name: 'chatbot',
  initialState,
  reducers: {
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload
    },
    setFarmChatResults(state, action: PayloadAction<any>) {
      state.farmChatResults = [...state.farmChatResults, action.payload]
    },
    setDataChatResults(state, action: PayloadAction<any>) {
      state.dataChatResults = [...state.dataChatResults, action.payload]
    },
    setIsloading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setQuestions(state, action: PayloadAction<{key: string, value: string}>) {
      const question = action.payload.value
      const storageKey = action.payload.key

      const _questions = localStorage.getItem(storageKey) || '[]'
      const questions: [string?] = JSON.parse(_questions)
      const _indexFound = questions.findIndex(r => r === question)

      if (_indexFound === -1) questions.push(question)

      localStorage.setItem(storageKey, JSON.stringify(questions))
    }
  }
})

export const { setEmail, setFarmChatResults, setIsloading, setQuestions, setDataChatResults } = chatbotSlice.actions
export default chatbotSlice.reducer

export const selectIsLoading = (state: RootState) => state.chatbot.isLoading;
export const selectFarmchatbotResult = (state: RootState) => state.chatbot.farmChatResults;
export const selectDatachatbotResult = (state: RootState) => state.chatbot.dataChatResults;
export const selectEmail = (state: RootState) => state.chatbot.email;
export const selectFarmChatLastId = (state: RootState) => {
  if (state.chatbot.farmChatResults && Array.isArray(state.chatbot.farmChatResults))
    return state.chatbot.farmChatResults.length.toString()

  return null;
}
export const selectDataChatLastId = (state: RootState) => {
  if (state.chatbot.dataChatResults && Array.isArray(state.chatbot.dataChatResults))
    return (state.chatbot.dataChatResults.length-1).toString()

  return null;
}